<template>
	<div class="pages">
		<!-- 管控manager  管理员admin -->
		<MANAGERHOME v-if="user.role == 'manager' || user.role == 'admin'"></MANAGERHOME>
		<!-- 工作人员officer -->
		<OFFICERHOME v-if="user.role == 'officer'"></OFFICERHOME>
		<!-- 会员member -->
		<USERRHOME v-if="user.role == 'member'"></USERRHOME>
	</div>
</template>
<script>
	import MANAGERHOME from "@/components/managerHome"
	import OFFICERHOME from "@/components/officerHome"
	import USERRHOME from "@/components/userHome"
	export default {
		name: "home",
		props: {},
		components: {
			OFFICERHOME,
			MANAGERHOME,
			USERRHOME
		},
		data() {
			return {
				user: null,
			};
		},
		computed: {},
		watch: {},
		mounted() {},
		created() {
			this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
			if (!this.user) {
				this.$router.push('/login')
			}
		},
		beforeDestroy() {

		},
		methods: {},
	};
</script>
<style>

</style>
